import api from './api';

export const ventasReportService = {
  async getDashboard(params = {}) {
    const response = await api.get('/ventas/reports/dashboard', { params });
    return response.data;
  },

  async getCashByShift(params = {}) {
    const response = await api.get('/ventas/reports/cash-by-shift', { params });
    return response.data;
  },

  async getSalesOverview(params = {}) {
    const response = await api.get('/ventas/reports/sales-overview', { params });
    return response.data;
  },

  async getSalesRegister(params = {}) {
    const response = await api.get('/ventas/reports/sales-register', { params });
    return response.data;
  },
};

export default ventasReportService;
